import { render, staticRenderFns } from "./LandingSlide.vue?vue&type=template&id=27e61744&"
import script from "./LandingSlide.vue?vue&type=script&lang=js&"
export * from "./LandingSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports